document.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector(".property-nav");
  const navLinks = document.querySelectorAll(".property-nav-link");

  // exit hatch
  if (!nav) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      nav.classList.add("visible-nav");
      nav.classList.remove("hidden-nav");
    } else {
      nav.classList.remove("visible-nav");
      nav.classList.add("hidden-nav");
    }
  });

  // Create a mapping of section IDs to nav links
  const sectionMap = {};
  navLinks.forEach((link) => {
    const id = link.getAttribute("href").replace("#", "");
    const section = document.getElementById(id);
    if (section) {
      sectionMap[id] = { section, link };
    }
  });

  // Use IntersectionObserver to track section visibility
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id;
        if (entry.isIntersecting) {
          navLinks.forEach((link) => link.classList.remove("active"));
          sectionMap[id]?.link.classList.add("active");
        }
      });
    },
    {
      threshold: 0.5, // adjust this as needed
    },
  );

  // Observe each section
  Object.values(sectionMap).forEach(({ section }) => observer.observe(section));
});
